export default {
  // General
  'saving-plan:general:more-info': 'Mehr Infos',

  // Selector
  'saving-plan:selector:title': 'Jahres-Vorteil',
  'saving-plan:selector:none': 'Ohne 0%',
  'saving-plan:selector:none:price': '0€ / Jahr',
  'saving-plan:selector:clever': 'Clever {badge}',
  'saving-plan:selector:clever:badge': 'ab 3%',
  'saving-plan:selector:clever:price': '2,99€ / Jahr',
  'saving-plan:selector:premium': 'Premium {badge}',
  'saving-plan:selector:premium:badge': 'ab 5%',
  'saving-plan:selector:premium:price': '7,99€ / Jahr',
  'saving-plan:selector:dynamic:badge': '{discount}%',
  'saving-plan:selector:price-info':
    'Für nur {price} €: Extra {discount}% Rabatt auf jeder Bestellung!',
  'saving-plan:selector:price-info:dynamic':
    'Für einmalig {price}: mind. {discount}% Extra-Rabatt pro Bestellung!',
  'saving-plan:selector:price-info:exact':
    'Für einmalig {price}: {discount}% Extra-Rabatt pro Bestellung!',

  // Info bar messages
  'saving-plan:info-bar:active':
    'Dein {planName}-Plan ist aktiv - schon mit {percentage}% Rabatt reduziert.',
  'saving-plan:info-bar:customer-plan':
    'Dein Jahres-Vorteil ({planName}) ist aktiv - mindestens {percentage} % Rabatt gesichert.',
  'saving-plan:info-bar:cart':
    'Mit deinem ausgewählten {planName}-Plan bereits {percentage}% günstiger',
  'saving-plan:info-bar:savings':
    'Dein Jahres-Vorteil {planName}: <strong>{amount}</strong> gespart.',
  'saving-plan:info-bar:account:page': 'Jahres-Vorteil {planName} {percentage}%',
  'saving-plan:info-bar:account:page:active-until': 'Aktiv bis {activeUntil}',
  'saving-plan:info-bar:account:page:more-info': 'Mehr Infos',
  'saving-plan:info-bar:account:page:more-info:label':
    'Weitere Informationen zu diesem Jahres-Vorteil',
  'saving-plan:info-bar:subscriptions:page':
    'Deine Spar-Abo-Produkte: {percentage}% günstiger mit Jahres-Vorteil {planName}',

  // Cart element
  'saving-plan:cart:banner': 'Jetzt {amount} bei dieser Bestellung sparen!',
  'saving-plan:cart:title:clever': 'Jahres-Vorteil Clever',
  'saving-plan:cart:title:premium': 'Jahres-Vorteil Premium',
  'saving-plan:cart:description': 'Jahres-Vorteil: Für ein Jahr bei jeder Bestellung sparen',
  'saving-plan:cart:benefit:pay-once': 'Einmal zahlen, 12 Monate sparen',
  'saving-plan:cart:benefit:discount': 'Rabatt auf Futter & Snacks',
  'saving-plan:cart:benefit:no-renewal': 'Keine automatische Verlängerung',
  'saving-plan:cart:price:clever': 'Einmalig 2,99 €',
  'saving-plan:cart:price:premium': 'Einmalig 7,99 €',
  'saving-plan:cart:activate': 'Jetzt aktivieren',
  'saving-plan:cart:pet-profile-benefit': 'Mehr sparen mit Tierprofil!',
  'saving-plan:cart:increase-discount': 'Rabatt erhöhen',

  // More info sheet
  'saving-plan:more-info:not-active:title': 'Extra-Rabatt bei jeder Bestellung',
  'saving-plan:more-info:active:title': 'Dein Jahres-Vorteil erklärt',
  'saving-plan:more-info:column:plan': 'Jahres-Vorteil',
  'saving-plan:more-info:column:discount': 'Rabatt',
  'saving-plan:more-info:none': 'Ohne - Kostenlos',
  'saving-plan:more-info:none:discount': '0%',
  'saving-plan:more-info:clever': 'Clever - 2,99 €/Jahr',
  'saving-plan:more-info:clever:without-profile': 'Ohne Tierprofil: 3%',
  'saving-plan:more-info:clever:with-profile': 'Mit Tierprofil: ab 5%',
  'saving-plan:more-info:premium': 'Premium - 7,99 €/Jahr',
  'saving-plan:more-info:premium:without-profile': 'Ohne Tierprofil: 5%',
  'saving-plan:more-info:premium:with-profile': 'Mit Tierprofil: ab 8%',
  'saving-plan:more-info:benefit:duration': '12 Monate Preisvorteil sichern',
  'saving-plan:more-info:benefit:no-renewal': 'Keine automatische Erneuerung',
  'saving-plan:more-info:benefit:all-products': 'Gilt für alle Futterarten & Snacks',
  'saving-plan:more-info:benefit:one-per-account': 'Ein Jahres-Vorteil pro Konto',
  'saving-plan:more-info:benefit:combinable': 'Auch kombinierbar mit Spar-Abo & Gutschein',
  'saving-plan:more-info:close': 'Schließen',

  // Login button
  'saving-plan:login-button:already-registered': 'Du bist schon registriert?',
  'saving-plan:login-button:login-here': 'Hier anmelden',

  // Editor
  'saving-plan:editor:title': 'Wähle deinen Jahres-Vorteil',
  'saving-plan:editor:info':
    'Für nur {value} €: Extra mind. {discount}% Rabatt auf jeder Bestellung!',
  'saving-plan:editor:cancel': 'Schließen',
  'saving-plan:editor:save': 'Auswahl speichern',
  'saving-plan:editor:close': 'Schließen',
};
